// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"bea1f1c3","381":"1ae58047","548":"6ad2f7d4"}[chunkId] + ".chunk.css";
};